const InvoiceThumbnail = ({
  id,
  isSelected,
  onSelect,
  onPreview,
  children,
  thunailclass,
}) => {const topPosition = thunailclass?.includes("invoiceHalfA4") ? "118px" : "215px";

  return (
  <div
    className={`${thunailclass} position-relative form-check custom-option
        custom-option-image custom-option-image-check
        ${isSelected ? "active" : ""} cursor-pointer`}
  >
    <input
      type="checkbox"
      checked={isSelected}
      onChange={onSelect}
      className="form-check-input bg-label-dark-blue"
      style={{
        top: topPosition,
        left: "8px",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        transform: "translateY(-50%)",
        zIndex: 2,
      }}
    />

    <div className="invoice-scale" onClick={onPreview}>
      {children}
    </div>
  </div>
);
};
export default InvoiceThumbnail;
